module.exports = __webpack_public_path__ + "static/media/illo-hat.eef9142f.png";